import { useState } from 'react';
import { Button, Tag, message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GenericList } from './common/GenericList';
import { $ } from '../lib/api';

export function RescuePage() {
  const qc = useQueryClient();
  // ux1：提醒/转让两钮 actingId 精确防重——只 loading 正在处理的那一行那个动作
  const [acting, setActing] = useState<string | null>(null);
  const handle = useMutation({
    mutationFn: ({ id, action }: any) => $.post(`/rescue/${id}/handle`, { action }),
    onMutate: ({ id, action }: any) => { setActing(`${id}:${action}`); },
    onSuccess: () => { message.success('已处理'); qc.invalidateQueries(); },
    onError: (e: any) => message.error(e?.message ?? '处理失败'),
    onSettled: () => { setActing(null); },
  });
  return (
    <GenericList
      endpoint="/rescue"
      title="客户救援列表（AI 标红）"
      columns={[
        { title: '客户 ID', dataIndex: 'customerId' },
        { title: '严重程度', dataIndex: 'severity', render: (s: string) =>
          <Tag color={s === 'critical' ? 'red' : s === 'warning' ? 'orange' : 'default'}>{s}</Tag> },
        { title: '原因', dataIndex: 'reason' },
        { title: 'AI 建议', dataIndex: 'aiRecommendation', ellipsis: true },
        { title: '状态', dataIndex: 'status' },
        { title: '操作', render: (_: any, r: any) =>
          r.status === 'open' && (
            <>
              <Button size="small" loading={acting === `${r.id}:remind_sales`} onClick={() => handle.mutate({ id: r.id, action: 'remind_sales' })}>提醒销售</Button>{' '}
              <Button size="small" loading={acting === `${r.id}:reassign`} onClick={() => handle.mutate({ id: r.id, action: 'reassign' })}>转让</Button>
            </>
          )
        },
      ]}
    />
  );
}
